import { Injectable } from '@angular/core';
import { Router, CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot  } from '@angular/router';
import { StorageService } from './StorageService';


@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router,private storage:StorageService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot){
        if ((this.storage.getSessionData())) {
            // logged in so return true
            return true;
        }

        // not logged in so redirect to login page
        this.router.navigate(['/login']);
        //this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/security/auth.guard.ts